import { replacePlaceholderLabels } from "@resource/common";
import DOMPurify from "isomorphic-dompurify";

type SanitizedTokenizedTextType = React.HTMLAttributes<HTMLParagraphElement> & {
  value: string;
  allowedTags?: string[];
  tokenReplacements?: Record<string, string>;
};
function SanitizedTokenizedText({
  allowedTags,
  tokenReplacements,
  value,
  ...textComponentProps
}: SanitizedTokenizedTextType) {
  const textWithValues = replacePlaceholderLabels(
    value,
    tokenReplacements ?? {}
  );
  const sanitizedText = DOMPurify.sanitize(textWithValues ?? "", {
    ALLOWED_TAGS: allowedTags ?? [],
  });
  return (
    <p {...textComponentProps}>
      <span
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sanitizedText,
        }}
      />
    </p>
  );
}

export default SanitizedTokenizedText;
